import React from 'react';
import { Grid, IconButton, Typography, styled } from '@mui/material';
import history from 'services/history';
import { ArrowBack } from '@mui/icons-material';

interface useStylesProps {
  gutterbottom: number;
}

const CustomGrid = styled(Grid)<useStylesProps>(props => ({
  marginBottom: props.gutterbottom ? 10 : 0,
  display: 'flex',
  gap: 5,
  alignItems: 'center',
  [props.theme.breakpoints.down('md')]: {
    paddingLeft: 0,
  },
  '@media print': {
    display: 'none',
  },
}));

const CustomIconButton = styled(IconButton)({
  marginRight: 15,
});

interface PageHeaderProps {
  title: string;
  description?: string;
  gutterbottom?: boolean;
  backUrl?: string;
}

const PageHeader: React.FC<PageHeaderProps> = ({ title, description, gutterbottom = true, backUrl }) => {
  return (
    <CustomGrid gutterbottom={gutterbottom ? 1 : 0}>
      {backUrl && (
        <CustomIconButton size="small" onClick={() => history.push(backUrl)}>
          <ArrowBack />
        </CustomIconButton>
      )}
      <div>
        <Typography variant="h6">{title}</Typography>
        {description && (
          <Typography color="textSecondary" variant="body2">
            {description}
          </Typography>
        )}
      </div>
    </CustomGrid>
  );
};

export default PageHeader;
